import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  title,
  subtitle,
  align = 'center'
}: SectionHeadingProps) {
  const centered = align === 'center';
  return <div className={centered ? 'text-center' : 'text-left'} data-id="element-65" data-mp="3f36q7i3iln6m">
      <h2 className={`max-w-4xl text-3xl font-black uppercase leading-tight tracking-tight text-ink md:text-5xl ${centered ? 'mx-auto' : ''}`} data-id="element-66" data-mp="3k185rt1qf4dc">{title}</h2>
      <div className={`mt-6 h-0.5 w-16 bg-accent ${centered ? 'mx-auto' : ''}`} aria-hidden="true" data-id="element-67" data-mp="gjgl6zpxdmp6" />
      {subtitle && <p className={`mt-6 max-w-3xl text-lg leading-relaxed text-muted md:text-xl ${centered ? 'mx-auto' : ''}`} data-id="element-68" data-mp="1utszxf790gj">{subtitle}</p>}
    </div>;
}